
function isOdd(num) {
    return num % 2;
}

// For Light-Go-live. Redirect all link to lead-page
function redirectAllLinksToLeadpage () {
    var urlpath =  window.location.href;
    var pageString = 'auf-die-platze-fertig-los';
    var pageStringDatenschutz = '/policies/privacy-policy';
    var pageStringImpressum = '/policies/legal-notice';
    
    if(urlpath.toLocaleLowerCase().indexOf(pageString.toLocaleLowerCase())==-1 
        && urlpath.toLocaleLowerCase().indexOf(pageStringDatenschutz.toLocaleLowerCase())==-1
        && urlpath.toLocaleLowerCase().indexOf(pageStringImpressum.toLocaleLowerCase())==-1) {
        window.location.href = '/pages/auf-die-platze-fertig-los'
    }

    $('a').on('click', function (e) {
        if($(this).attr('href').toLocaleLowerCase().indexOf(pageStringImpressum.toLocaleLowerCase())==-1
        && $(this).attr('href').toLocaleLowerCase().indexOf(pageStringDatenschutz.toLocaleLowerCase())==-1 ){
            e.preventDefault();
            window.location.href="/pages/auf-die-platze-fertig-los"
        }
    });
}


$(function () {

    $('.ads_js__form_submit_add').on('click', function () {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    });

    //Begin BACK TO TOP - Get the button
    if ($(window).width() > 749 && $('.template-product').length > 0 ) {
        var mybutton = document.getElementById("backtToTop");
        window.onscroll = function() {scrollFunction()};

        function scrollFunction() {
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                mybutton.style.display = "flex";
            } else {
                mybutton.style.display = "none";
            }
        }

        $('#backtToTop').on('click', function () {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        });
    }
    // END BACK TO TOP 

    // for custom rich text section
    $('div.richtextTemplate').each(function (index) {
        if (index != 0) {
            if (isOdd(index)) {
                $(this).addClass("richtextTemplate_pair");
                if (index == $('div.richtextTemplate').length - 1) {
                    $(this).addClass("richtextTemplate_last_pair");
                }
            } else {
                $(this).addClass("richtextTemplate_impair");
                if (index == $('div.richtextTemplate').length - 1) {
                    $(this).addClass("richtextTemplate_last_impair");
                }
            }

        } else {
            $(this).addClass("richtextTemplate_first_pair");
            if(index == $('div.richtextTemplate').length - 1){
                $(this).addClass("richtextTemplate_first_last_impair");
            }
        }
    });

    // to convert sticky submit button to add to cart button
    $('.ads_js__sticky_submit_add').on('click', function () {
        try {
            $('.ads_js__form_submit_add').click();
        } catch (e) {
            console.warn(e);
        }
        return false;
    });
    
    // to display swipe buttons on mobile

    $('#right-button').click(function() {
        var widthDiv = $('.sec-tab-collection .product-grid>.product-item').width();
        var count = $(".sec-tab-collection .product-grid>.product-item").length;
        if($('.sec-tab-collection .product-grid--mobile-slider').scrollLeft()>=0){
            $('#left-button').show();
        }
        if(widthDiv*(count-3)<$('.sec-tab-collection .product-grid--mobile-slider').scrollLeft()){
            $('#right-button').hide();
            $('#left-button').show();
        }
        event.preventDefault();
        $('.sec-tab-collection .product-grid--mobile-slider').animate({
          scrollLeft: `+=${widthDiv}`
        }, "slow");
     });
     
       $('#left-button').click(function() {
        var widthDiv = $('.sec-tab-collection .product-grid>.product-item').width();
        if($('.sec-tab-collection .product-grid--mobile-slider').scrollLeft()<$('.sec-tab-collection .product-item').width()+100){
            $('#left-button').hide();
            $('#right-button').show();
        }
        event.preventDefault();
        $('.sec-tab-collection .product-grid--mobile-slider').animate({
          scrollLeft: `-=${widthDiv}`
        }, "slow");
     });


     // to display swipe buttons on mobile

    $('#right-button-1').click(function() {

        var widthDiv = $('.product-grid>.product-item').width();
        var count = $(".product-grid>.product-item").length;
        if($('.product-grid--mobile-slider').scrollLeft()>=0){
            $('#left-button-1').show();
        }
        if(widthDiv*(count-3)<$('.product-grid--mobile-slider').scrollLeft()){
            $('#right-button-1').hide();
            $('#left-button-1').show();
        }
        event.preventDefault();
        $('#shopify-section-collection-row .product-grid--mobile-slider').animate({
          scrollLeft: `+=${widthDiv}`
        }, "slow");
     });
     
       $('#left-button-1').click(function() {
        var widthDiv = $('.product-grid>.product-item').width();
        if($('.product-grid--mobile-slider').scrollLeft()<$('.product-item').width()+100){
            $('#left-button-1').hide();
            $('#right-button-1').show();
        }
        event.preventDefault();
        $('#shopify-section-collection-row .product-grid--mobile-slider').animate({
          scrollLeft: `-=${widthDiv}`
        }, "slow");
     });
     /* Dynamic navigation slider even (refer to nivigation-slider.liquid)*/
     //right
     $('.right-button-slider').click(function() {    
        var unique_id = "#"+$(this).attr("unique_id"); 

        var widthDiv = $(unique_id+' .product-grid>.product-item').width();
        var count = $(unique_id+'>.product-grid>.product-item').length;
        if($(unique_id+' .product-grid--mobile-slider').scrollLeft()>=0){
            $(unique_id+"_btn_left").show();
        }
        if(widthDiv*(count+3)<$(unique_id+' .product-grid--mobile-slider').scrollLeft()){
            $(unique_id+"_btn_right").hide();
            $(unique_id+"_btn_left").show();
        }
        event.preventDefault();

        $(unique_id+' .product-grid--mobile-slider').animate({
          scrollLeft: `+=${widthDiv}`
        }, "slow");
     });
     //left
     $('.left-button-slider').click(function() {
        var unique_id = "#"+$(this).attr("unique_id"); 

        var widthDiv = $(unique_id+' .product-grid>.product-item').width();
        if($(unique_id+' .product-grid--mobile-slider').scrollLeft()<$(unique_id+' .product-item').width()+100){
            $(unique_id+"_btn_left").hide();
            $(unique_id+"_btn_right").show();
        }
        event.preventDefault();
        $(unique_id+' .product-grid--mobile-slider').animate({
          scrollLeft: `-=${widthDiv}`
        }, "slow");
     });
});

$('.button-handle').click(function () {
    if ($(window).width() > 749) {
        $('.nav-for-mobile').hide()
        $('.nav-for-desktop').slideToggle()
    }
    else {
        $('.nav-for-desktop').hide()
        $('.nav-for-mobile').slideToggle() 
    }
    $(this).toggleClass('isoppen')
});
function setBadgePostion() {
    if ($('.middlebackground-section').length > 0) {
        var element_position = $('.middlebackground-section').eq(0).offset().top;
        var y_scroll_pos = window.pageYOffset;
        var scroll_pos_test = element_position;
        if (y_scroll_pos + 90 > scroll_pos_test) {
            $('.middlebackground-section').eq(0).find('.hero-disturber').removeClass('hero-disturber-floating')
        }
        else {
            $('.middlebackground-section').eq(0).find('.hero-disturber').addClass('hero-disturber-floating')
        }
    }
    }
    setTimeout(function () {
        setBadgePostion();
    }, 500);

    $(window).on('scroll', function() {
        setBadgePostion();
    });
$('.all_article').click(function () {
    $('.article').removeClass('no-display')
});